import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import clone from 'clone'
import numeral from 'numeral'
import helpers from "helpers/helpers"
import FullTable from "components/FullTable"

class PriceParticipation extends Component {
	constructor(props) {
		super(props)

		this.state = {
			priceParticipation__supplyColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
				},
				{
					Header: "Particpation %",
					accessor: "percent",
					display: true,
				},
				{
					Header: "Price Participation Closing Date",
					accessor: "closing_date",
					display: true,
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Home Sales Price",
					accessor: "price",
					display: true,
					Cell: (v) => {
						if (v.value) {
							return `$${v.value.toLocaleString()}`
						}
						return ""
					},
				},
				{
					Header: "Addl Home Sale Price Participation Fee",
					accessor: "participation_fee",
					display: true,
					className: "right",
					Cell: (v) => {
						if (v.value) {
							return `$${v.value.toLocaleString()}`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v._original.fee_num
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0.00")
						}
						return total
					},
				},
				{
					Header: "Partial Release of Deed of Trust Recording #",
					accessor: "dot_partial_release",
					display: true,
				},
			],
			priceParticipation__overallColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
				},
				{
					Header: "Particpation %",
					accessor: "percent",
					display: true,
				},
				{
					Header: "Price Participation Closing Date",
					accessor: "closing_date",
					display: true,
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Home Sales Price",
					accessor: "price",
					display: true,
					Cell: (v) => {
						if (v.value) {
							return `$${v.value.toLocaleString()}`
						}
						return ""
					},
				},
				{
					Header: "Addl Home Sale Price Participation Fee",
					accessor: "participation_fee",
					display: true,
					className: "right",
					Cell: (v) => {
						if (v.value) {
							return `${v.value.toLocaleString()}`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v._original.fee_num
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0.00")
						}
						return total
					},
				},
				{
					Header: "Partial Release of Deed of Trust Recording #",
					accessor: "dot_partial_release",
					display: true,
				},
			],
			sorted: [],
			overall: [],
		}
	}

	supply = () => {
		let ret = []
		let lots = _.filter(this.props.payload.exec.lots, (v) => {
			if (
				v.date_hud_closing >= this.props.currentDates.startStamp &&
				v.date_hud_closing < this.props.currentDates.endStamp
			) {
				return v
			}
		})
		_.forEach(lots, (r) => {
			if (!r.date_hud_closing) {
				return
			}

			let section = _.find(this.props.payload.public.sections, { id: r.section_id })
			if (!section) {
				return
			}
			let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			if (!lotType) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (!builder) {
				return
			}
			ret.push({
				lot_type: lotType.name,
				builder: builder.name,
				section: r.section_name,
				block: r.block,
				lot: r.lot,
				address: r.address,
				closing_date: r.date_hud_closing,
				price: r.sale_price,
				percent: r.price_partic_percent,
				participation_fee: r.price_partic_fee ? Math.round(r.price_partic_fee * 100) / 100 : "0.00",
				fee_num: r.price_partic_fee ? r.price_partic_fee : 0,
				dot_partial_release: r.dot_partial_release,
			})
		})
		return ret
	}

	renderFilters = (set) => {
		let checkboxes = []
		_.forEach(this.state[set], (v) => {
			let index = _.findIndex(this.state[set], { Header: v.Header })
			checkboxes.push(
				<li
					className="filterCheckboxes__item"
					key={v.Header}
					data-value={v.Header}
					onClick={(e) => this.filterChange(e, set)}>
					<input
						type="checkbox"
						name={v.Header}
						value={v.Header}
						checked={this.state[set][index].display}
						onChange={(e) => this.filterChange(v.Header, set)}
					/>
					{v.Header}
				</li>
			)
		})

		return checkboxes
	}

	checkAll = (set, value) => {
		let state = clone(this.state)
		_.forEach(state[set], (v, k) => {
			state[set][k].display = value
		})
		this.storePref(set, state)
		this.setState(state)
	}

	overallSupply = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (r) => {
			let section = _.find(this.props.payload.public.sections, { id: r.section_id })
			if (!section) {
				return
			}
			let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			if (!lotType) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (!builder) {
				return
			}
			ret.push({
				lot_type: lotType.name,
				builder: builder.name,
				section: r.section_name,
				block: r.block,
				lot: r.lot,
				address: r.address,
				closing_date: r.date_hud_closing,
				price: r.sale_price,
				percent: r.price_partic_percent,
				participation_fee: r.price_partic_fee ? Math.round(r.price_partic_fee * 100) / 100 : "0.00",
				fee_num: r.price_partic_fee ? r.price_partic_fee : 0,
				dot_partial_release: r.dot_partial_release,
			})
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="inventory">
					<div className="imageGroup">
						<Title title="Price Participation Fee Report" />
						<div className="content inventory__content">
							<FullTable
								data={this.supply()}
								columns={this.state.priceParticipation__supplyColumns}
								name="pricParticipation__fee"
								title="Price Particiaption"
								unset={["fee_num"]}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content inventory__content">
							<h3>Overall Status</h3>
							<FullTable
								data={this.overallSupply()}
								columns={this.state.priceParticipation__overallColumns}
								name="pricParticipation__overall"
								title="Price Particiaption Overall"
								unset={["fee_num"]}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload,
        payloadStatus: state.payloadStatus
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(PriceParticipation)
